function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M71.5,38.4h-2.8v-.5c-1.1-14.2-12.4-25.5-26.6-26.6h-.5v-2.8c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6,1.6v2.8h-.5c-14.2,1.1-25.5,12.4-26.6,26.6v.5h-2.8c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6h2.8v.5c1.1,14.2,12.4,25.5,26.6,26.6h.5v2.8c0,.9.7,1.6,1.6,1.6s1.6-.7,1.6-1.6v-2.8h.5c14.2-1.1,25.5-12.4,26.6-26.6v-.5h2.8c.9,0,1.6-.7,1.6-1.6s-.7-1.6-1.6-1.6M38.4,57.2v8.4l-.6-.1c-12.4-1-22.3-10.9-23.3-23.3l-.1-.6h8.9l.1.5c.9,7.6,6.9,13.6,14.6,14.6l.5.1-.1.4ZM65.5,42.2c-1,12.4-10.9,22.3-23.3,23.3l-.6.1v-8.9l.5-.1c6-.7,11.2-4.7,13.5-10.3.3-.8-.1-1.7-.9-2s-1.7.1-2,.9h0c-1.8,4.4-5.7,7.6-10.4,8.3l-.7.1v-6.4c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6,1.6v6.4l-.7-.1c-5.7-1-10.2-5.5-11.2-11.2l-.1-.7h6.4c.9,0,1.6-.7,1.6-1.6s-.7-1.6-1.6-1.6H14.4l.1-.6c1-12.4,10.9-22.3,23.3-23.3l.6-.1v8.9l-.5.1c-6,.7-11.2,4.7-13.5,10.3-.3.8.1,1.7.9,2s1.7-.1,2-.9h0c1.8-4.4,5.7-7.6,10.4-8.3l.7-.1v6.4c0,.9.7,1.6,1.6,1.6s1.6-.7,1.6-1.6h0v-6.4l.7.1c5.7,1,10.2,5.5,11.2,11.2l.1.7h-6.4c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6h18.4l-.1.6ZM64.9,38.4h-8.2l-.1-.5c-.9-7.6-6.9-13.6-14.6-14.6l-.5-.1v-8.9l.6.1c12.4,1,22.3,10.9,23.3,23.3l.1.6-.6.1Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,37.7c-1.2,0-2.3.9-2.3,2.2v.1c0,.6.2,1.2.7,1.7.9.9,2.4.9,3.3,0,.9-.9.9-2.4,0-3.3-.5-.5-1.1-.7-1.7-.7"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Shooting-inactive.f43f95a0.svg";
export { SvgComponent as ReactComponent };